import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTransloco } from '@jsverse/transloco';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { AppRoutingModule } from './app/app-routing.module';
import { OneWebComponentsAngularModule } from '@one/angular';
import { MacAddressModule } from './app/features/mac-address/mac-address.module';
import { appInitializerProvider } from './app/core/app-initializer/app-initializer.service';
import { TranslocoRootModule } from './app/transloco-root.module';
import { ENVIRONMENT } from './app/core/models/environment.token';
import { TranslocoHttpLoader } from './app/transloco-loader';

if (environment.production) {
  enableProdMode();
}


bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule,OneWebComponentsAngularModule, MacAddressModule,TranslocoRootModule),
    appInitializerProvider,
    ...environment.providers,
    { provide: ENVIRONMENT, useValue: environment },
    provideHttpClient(withInterceptorsFromDi()),
  
   //transloco config
   provideTransloco({
    config: {
      availableLangs: ['en-US'],
      defaultLang: 'en-US',
      fallbackLang: 'en-US',
      missingHandler: {
        useFallbackTranslation: true,
      },
      reRenderOnLangChange: true,
      prodMode: environment.production,
    },
    loader: TranslocoHttpLoader,
  }),
],
}).catch(err => console.error(err));


